import React from 'react'
import PropTypes from 'prop-types'
import './Owner.css'

const Owner = ({ className, owner }) => {
    const tooltipText = 'Copy wallet address to clipboard'
    const classNames = `owner ${className}`
    const id = `tooltip-${owner.name}`

    const copyToClipboard = owner => {
        navigator.clipboard.writeText(owner.wallet)

        const tooltip = document.getElementById(id)
        tooltip.innerHTML = `Copied: ${owner.wallet}`
    }

    return (
        <>
            <div className={classNames} onClick={() => copyToClipboard(owner)}>
                Owned by: {owner ? owner.name : 'UNAVAILABLE'}
                <div className="tooltiptext" id={id}>
                    {tooltipText}
                </div>
            </div>
        </>
    )
}

Owner.propTypes = {
    className: PropTypes.string,
    hero: PropTypes.object,
}

Owner.defaultProps = {}

export default Owner
